import { render, staticRenderFns } from "./NewAlbum.vue?vue&type=template&id=f9c9dd30"
import script from "./NewAlbum.vue?vue&type=script&lang=js"
export * from "./NewAlbum.vue?vue&type=script&lang=js"
import style0 from "./NewAlbum.vue?vue&type=style&index=0&id=f9c9dd30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports